<div class="blueprint-summary">
    <div class="pt-8 pl-72 pr-72 pb-8">
      <app-breadcrumb [items]="breadcrumbItems" class="breadcrumb"></app-breadcrumb>
    </div>
    <div class="bookmark" [ngClass]="{'dr-in-progress': (showDRBanner$ | async)}">
      <img class="tag" src="/assets/images/tag.svg" />
      <span class="mat-body fs-12 fw-500 tag-text">{{'INSTANCE_DETAILS.SERVICE_DEFINITION' | transloco}}</span>
    </div>
     
  <div class="flex flex-row justify-between mb-24 header-background-color header">
    <div class="flex flex-row flex-auto pl-72 pr-72 pb-20" [ngClass]="isExternalTenant ? 'pt-32' : 'pt-12'">
      <div class="flex flex-row pt-6">
        <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0"
          [routerLink]="['/', authService.principal.provider, RouterSegments.TENANT, tenantData?.tenantId, RouterSegments.SERVICE_DEFINITION]"></mat-icon>
      </div>
      <div class="flex flex-col flex-auto justify-between pl-24">
        <div class="flex flex-row justify-between mb-12 instance-name">
          <div *ngIf="blueprint?.name; else headerLoader" class="mat-subtitle-1 fw-600 fs-32 mb-0">{{ blueprint?.name }}</div>

          <div *ngIf="!isExternalTenant" class="flex flex-row justify-center items-center mt-30">
            <div class="flex justify-center items-center mr-16" [ngClass]="isLive ? 'green-oval' : 'orange-oval'">
              <mat-icon *ngIf="isLive" svgIcon="done" class="icon-sm"></mat-icon>
              <mat-icon *ngIf="!isLive" svgIcon="change_circle" class="icon-sm"></mat-icon>
            </div>
            <div class="mat-subtitle-2 fw-600 mb-0">{{'SERVICE_STATUS.' + (!isLive ? 'IN_PROGRESS' : 'LIVE') | transloco }}</div>
            <div class="actions">
              <button class="flex justify-center items-center context-menu-icon pr-0"
                [matMenuTriggerFor]="blueprintActionsMenu">
                <mat-icon svgIcon="more_vert"></mat-icon>
              </button>
              <mat-menu #blueprintActionsMenu [xPosition]="'before'" class="context-menu">
                <div class="flex-col" matTooltipClass="above" matTooltipPosition="above"
                  [matTooltip]="allInstances?.length > 0 ? ('BLUEPRINT_SUMMARY.TERMINATE_INSTANCES_BEFORE_DELETE' | transloco) : null">
                  <button class="delete-button" (click)="(allInstances?.length === 0 && permissionsMap[PermissionKeys.BLUEPRINT_DELETE]) ? deleteBlueprint() : ''"
                    [disabled]="allInstances?.length > 0 || !permissionsMap[PermissionKeys.BLUEPRINT_DELETE]"
                    [ngClass]="(allInstances?.length > 0 || !permissionsMap[PermissionKeys.BLUEPRINT_DELETE]) ? 'disabled' : '' ">
                    <div class="flex items-center">
                      <mat-icon svgIcon="delete" class="icon red"></mat-icon>
                      <div class="mat-body-1 m-0 fw-400 red">{{'BUTTONS.DELETE' | transloco}}</div>
                    </div>
                  </button>
                </div>
              </mat-menu>
            </div>
          </div>

        </div>
        <div class="flex justify-between">
          <div *ngIf="!isExternalTenant" class="flex flex-row sub-header items-center mt--4">
            <div *ngIf="solution?.name; else loader" class="vertical-indicator fs-14 fw-400 pr-16 flex items-center">{{solution?.name}}</div>

            <div class="flex flex-row justify-center items-center vertical-indicator fs-14 fw-400 ml-16 pr-16">
              <mat-icon svgIcon="place" class="icon-sm mr-6"></mat-icon>
              {{(tenantData?.regionPair || tenantData?.temenosRegion) | titlecase}}
            </div>

            <div *ngIf="serviceVersionsInfo?.currentVersion?.releaseVersion || serviceVersionsInfo?.devVersion?.releaseVersion" class="flex flex-row justify-center items-center fs-14 fw-400 ml-16 pr-16">
              <mat-icon svgIcon="token" class="icon-sm mr-6"></mat-icon>
              <span class="mr-10">{{('BLUEPRINT_SUMMARY.RELEASE_VERSION' | transloco) + ' ' + (latestReleaseVersion ? latestReleaseVersion : this.sortedSolutionVersionId[0]?.releaseVersion) }}</span>
              <div *ngIf="isAMR" class="flex flex-row justify-center items-center vertical-dash pl-10">
                {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
              </div>
            </div>

            <!-- <div class="flex flex-row pl-16 fs-14 fw-400">
              <mat-icon svgIcon="open_in_new" class="icon-sm mt-1 mr-4"></mat-icon>
              <div>
                <a class="view-release-internal-link cursor-pointer pb-0"
                *ngIf="viewReleaseNotes; else releaseNotesDisabled" [href]="viewReleaseNotes"
                target="_blank">{{'BLUEPRINT_SUMMARY.RELEASE_NOTES' | transloco}}</a>
              <ng-template #releaseNotesDisabled>
                <div class="view-release-internal-link disabled-link cursor-default">
                  {{'BLUEPRINT_SUMMARY.RELEASE_NOTES' | transloco}}</div>
              </ng-template>
              </div>
            </div> -->
          </div>
          <ng-template #loader>
              <div class="pl-6 skeleton-loader vertical-indicator pr-16">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
            <ng-template #headerLoader>
              <div class="pl-6 skeleton-loader-header">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row">
    <!-- <div class="bg-gradient left-menu">
      <ng-container *ngFor="let header of verticalMenuItems">
        <div class="text-color pl-12">
          <span class="fs-12">{{ header.nameKey | transloco }}</span>
        </div>
        <mat-nav-list>
          <ng-container *ngFor="let item of header.items">
            <mat-list-item (click)="item.expanded = !item.expanded; !item?.disabled && menuItemClicked(item)" [ngClass]="{'selected-menu': (item?.nameKey === selectedMenu?.nameKey), 'disable': item?.disabled}">
              <mat-icon *ngIf="item.icon" mat-list-icon [svgIcon]="item.icon" class="icon-md-1 cursor-pointer mt-14 mb-14 ml-4 mr-4 sub-menu"
                [ngClass]="{'selected-menu': item?.nameKey === selectedMenu?.nameKey}"></mat-icon>
              <span class="w-100-percent text-color mat-subtitle-2 fw-700 sub-menu" [ngClass]="{'selected-menu': item?.nameKey === selectedMenu?.nameKey}">{{ item.nameKey | transloco }}</span>
              <mat-icon class="menu-button text-background-color" [svgIcon]="item.expanded ? 'expand_less' : 'expand_more'" *ngIf="item.items"></mat-icon>
            </mat-list-item>
            <div class="pl-30 submenu text-color" [ngClass]="{'expanded': item.expanded}">
              <ng-container *ngIf="item.expanded && item.items">
                <ng-container *ngFor="let subItem of item.items">
                  <mat-list-item (click)="subItem.expanded = !subItem.expanded; menuItemClicked(subItem)"  class="menu-item">
                    <mat-icon *ngIf="subItem.icon" mat-list-icon [svgIcon]="subItem.icon" class="icon-md-1 cursor-pointer m-4"></mat-icon>
                    <span class="w-100-percent text-color">{{ subItem.nameKey | transloco }}</span>
                    <mat-icon class="menu-button text-background-color" [svgIcon]="subItem.expanded ? 'expand_less' : 'expand_more'" *ngIf="subItem.items"></mat-icon>
                  </mat-list-item>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </mat-nav-list>
      </ng-container>
    </div> -->
    <div *ngIf="selectedMenu?.nameKey === 'BLUEPRINT_SUMMARY.INSTANCES' && blueprint && tenantId" class="w-100-percent">
      <app-tenant-instance [blueprint]="blueprint" [tenantId]="tenantId" (deleteBlueprints)="deleteBp($event)"></app-tenant-instance>
    </div>
    <div *ngIf="selectedMenu?.nameKey === 'BLUEPRINT_SUMMARY.DISASTER_RECOVERY'" class="w-100-percent">
      <app-disaster-recovery [blueprint]="blueprint"></app-disaster-recovery>
    </div>
  </div>
</div>
